import { createContext, ReactNode } from 'react';

export type FootnoteContextType = {
    add: (footnote: ReactNode) => () => void;
    footnotes: any[];
};

export const FootnoteContext = createContext<FootnoteContextType>(null as any);
